// extracted by css-extract-rspack-plugin
export default {"step":"MiJ_rMwxtnMXOCud","heading":"D2IvkgeF78DMxpGu","body":"_2Aqto8Yb5Q3Z6GE"};